import React from "react";
import { connect } from "react-redux";
import { enteredHomePage, leavingHomePage } from "../../actions";

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount = () => {
    this.props.enteredHomePage();
    this.renderCaptchaJS();
  };

  renderCaptchaJS = () => {
    if (!this.instance) return;
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.innerHTML = 'function timestamp() { var response = document.getElementById("g-recaptcha-response"); if (response == null || response.value.trim() == "") {var elems = JSON.parse(document.getElementsByName("captcha_settings")[0].value);elems["ts"] = JSON.stringify(new Date().getTime());document.getElementsByName("captcha_settings")[0].value =JSON.stringify(elems);}}setInterval(timestamp, 500);';
    this.instance.appendChild(s);
  };

  componentWillUnmount = () => {
    this.props.leavingHomePage();
  };

  executeScroll = () =>
    this.myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

  render() {
    return (
      <div id="page-home">
        {/* Hero Section */}
        <section className="landing-hero">
          <div className="landing-hero__container">
            <div className="landing-hero__content">
              <h1 className="landing-hero__headline">
                Convert mobile shoppers into mobile buyers
              </h1>
              <p className="landing-hero__subheadline">
                Tap2Buy is designed to make buying on mobile frictionless, easy and fast.
              </p>
              <p className="landing-hero__description">
                No more typing on tiny keyboards. No more abandoned carts. Just one tap to purchase
                using your customer's phone as their secure identity.
              </p>
              <button
                className="landing-hero__cta"
                onClick={() => this.executeScroll()}
              >
                Show me more
              </button>
            </div>
            <div className="landing-hero__image">
              <img src="/tap2buy-image.png" alt="Tap2Buy mobile checkout" />
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="landing-features">
          <div className="landing-features__header">
            <span className="landing-features__badge">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 22C9.55228 22 10 21.5523 10 21V18H14V21C14 21.5523 14.4477 22 15 22H18C18.5523 22 19 21.5523 19 21V12H21C21.4045 12 21.7691 11.7564 21.9239 11.3827C22.0787 11.009 21.9931 10.5789 21.7071 10.2929L12.7071 1.29289C12.3166 0.902369 11.6834 0.902369 11.2929 1.29289L2.29289 10.2929C2.00689 10.5789 1.9213 11.009 2.07612 11.3827C2.23093 11.7564 2.59557 12 3 12H5V21C5 21.5523 5.44772 22 6 22H9Z" fill="currentColor"/>
              </svg>
            </span>
            <h2 className="landing-features__title">A truly mobile checkout</h2>
            <p className="landing-features__subtitle">
              Deliver a unique checkout experience for your mobile customers.
            </p>
          </div>
          <div className="landing-features__grid">
            <div className="landing-features__card">
              <div className="landing-features__card-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="23" stroke="#022a1e" strokeWidth="2"/>
                  <path d="M32 18L24 26L20 22" stroke="#def54c" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M16 16V32H32" stroke="#022a1e" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="landing-features__card-title">Send targeted sales campaigns</h3>
              <p className="landing-features__card-description">
                Reach customers directly via SMS with personalized offers and promotions that drive immediate action.
              </p>
            </div>
            <div className="landing-features__card">
              <div className="landing-features__card-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="23" stroke="#022a1e" strokeWidth="2"/>
                  <rect x="16" y="16" width="16" height="16" rx="2" stroke="#022a1e" strokeWidth="2"/>
                  <path d="M20 24H28M24 20V28" stroke="#def54c" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="landing-features__card-title">Easy product management</h3>
              <p className="landing-features__card-description">
                Upload, organize, and manage your product catalog with an intuitive dashboard built for speed.
              </p>
            </div>
            <div className="landing-features__card">
              <div className="landing-features__card-icon">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="24" cy="24" r="23" stroke="#022a1e" strokeWidth="2"/>
                  <path d="M24 16V24L28 28" stroke="#def54c" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M32 24C32 28.4183 28.4183 32 24 32C19.5817 32 16 28.4183 16 24C16 19.5817 19.5817 16 24 16" stroke="#022a1e" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h3 className="landing-features__card-title">Zero friction fast checkout</h3>
              <p className="landing-features__card-description">
                One tap purchase using the phone as secure identity. No passwords, no forms, no frustration.
              </p>
            </div>
          </div>
        </section>

        {/* Additional Features Section */}
        <section className="landing-additional">
          <div className="landing-additional__header">
            <h2 className="landing-additional__title">Additional features</h2>
            <p className="landing-additional__subtitle">
              Manage and promote products to your customers via text message marketing.
            </p>
          </div>
          <div className="landing-additional__grid">
            <div className="landing-additional__card">
              <div className="landing-additional__card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 8H4V6H20V8ZM20 10H4V12H20V10ZM20 14H4V16H20V14ZM20 18H4V20H20V18Z" fill="#def54c"/>
                </svg>
              </div>
              <h3 className="landing-additional__card-title">Automated stock management</h3>
              <p className="landing-additional__card-description">
                Real-time inventory sync keeps your stock levels accurate across all channels.
              </p>
            </div>
            <div className="landing-additional__card">
              <div className="landing-additional__card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12.88 17.76V19H11.12V17.71C9.47 17.4 8.18 16.36 8.06 14.73H9.82C9.93 15.54 10.53 16.13 12 16.13C13.59 16.13 14.05 15.41 14.05 14.94C14.05 14.33 13.59 13.76 11.74 13.31C9.66 12.79 8.17 11.92 8.17 10.09C8.17 8.54 9.43 7.53 11.12 7.24V6H12.88V7.26C14.62 7.64 15.52 8.88 15.58 10.27H13.82C13.77 9.43 13.28 8.87 12 8.87C10.78 8.87 10.03 9.39 10.03 10.06C10.03 10.64 10.48 11.06 12.26 11.51C14.04 11.96 15.91 12.7 15.91 14.91C15.91 16.52 14.62 17.48 12.88 17.76Z" fill="#def54c"/>
                </svg>
              </div>
              <h3 className="landing-additional__card-title">Payment engine</h3>
              <p className="landing-additional__card-description">
                Secure payment processing with support for all major payment methods.
              </p>
            </div>
            <div className="landing-additional__card">
              <div className="landing-additional__card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="#def54c"/>
                </svg>
              </div>
              <h3 className="landing-additional__card-title">Personalise your offer</h3>
              <p className="landing-additional__card-description">
                Tailor product recommendations and offers based on customer behavior and preferences.
              </p>
            </div>
            <div className="landing-additional__card">
              <div className="landing-additional__card-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z" fill="#def54c"/>
                </svg>
              </div>
              <h3 className="landing-additional__card-title">A/B testing</h3>
              <p className="landing-additional__card-description">
                Test different offers and messaging to optimize conversion rates and revenue.
              </p>
            </div>
          </div>
        </section>

        {/* Demo Request Section */}
        <section className="landing-demo" ref={this.myRef}>
          <div className="landing-demo__container">
            <h2 className="landing-demo__title">Request a Demo</h2>
            <p className="landing-demo__subtitle">
              See how Tap2Buy can transform your mobile commerce experience.
            </p>
            <div className="landing-demo__form">
              <form
                action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
                method="POST"
              >
                <input
                  type="hidden"
                  name="captcha_settings"
                  value='{"keyname":"recaptcha","fallback":"true","orgId":"00D5i000001tlvP","ts":""}'
                />
                <input type="hidden" name="oid" value="00D5i000001tlvP" />
                <input
                  type="hidden"
                  name="retURL"
                  value="/browse"
                />

                <div className="landing-demo__form-row">
                  <input
                    className="landing-demo__input"
                    id="first_name"
                    maxLength="40"
                    name="first_name"
                    type="text"
                    placeholder="First name"
                  />
                  <input
                    className="landing-demo__input"
                    id="last_name"
                    maxLength="80"
                    name="last_name"
                    type="text"
                    placeholder="Last name"
                  />
                </div>

                <input
                  className="landing-demo__input"
                  id="company"
                  maxLength="40"
                  name="company"
                  type="text"
                  placeholder="Company name"
                />

                <input
                  className="landing-demo__input"
                  id="email"
                  maxLength="80"
                  name="email"
                  type="email"
                  placeholder="Email address"
                />

                <div className="landing-demo__form-row">
                  <input
                    className="landing-demo__input"
                    id="phone"
                    maxLength="40"
                    name="phone"
                    type="tel"
                    placeholder="Phone number"
                  />
                  <input
                    className="landing-demo__input"
                    id="country"
                    maxLength="40"
                    name="country"
                    type="text"
                    placeholder="Country"
                  />
                </div>

                <div className="landing-demo__checkbox">
                  <input
                    id="00N5i00000EC5Bb"
                    name="00N5i00000EC5Bb"
                    type="checkbox"
                    value="1"
                  />
                  <label htmlFor="00N5i00000EC5Bb">
                    I agree to receive communications from intouch.
                  </label>
                </div>

                <p className="landing-demo__privacy">
                  By creating this request, we'll send you information around our products,
                  services and special offers. You can opt-out at any time, view our{" "}
                  <a href="https://intouch.digital/privacy-policy">privacy policy</a>.
                </p>

                <div
                  className="g-recaptcha"
                  data-sitekey="6LeQ5R4UAAAAANEhkPrEY5zvbEAd8Rq7UIDOlc-h"
                ></div>

                <button type="submit" className="landing-demo__submit">
                  Request Demo
                </button>
              </form>
            </div>
          </div>
        </section>

        <div ref={el => (this.instance = el)} />
      </div>
    );
  }
}

export default connect(null, { enteredHomePage, leavingHomePage })(HomePage);
